<template>
  <div :class="[$attrs.class, { 'pr-8 lg:pr-12': contactLink }]">
    <label v-if="label" class="form-label" :for="id">{{ label }}:</label>
    <select
      :id="id"
      ref="input"
      v-model="selected"
      v-bind="{ ...$attrs, class: null }"
      class="form-select"
      :class="{ error: error }"
      @change="handleChange"
    >
      <slot />
    </select>
    <div v-if="contactLink" class="absolute float-right right-0 top-9 mr--10 lg:mr-5">
      <a :href="contactLink" class="text-sm">
        <div class="float-right">
          <i class="ml-2 text-lg fas fa-user text-blue-500" />
        </div>
      </a>
    </div>
    <div v-if="error" class="form-error">{{ error }}</div>
  </div>
</template>

<script>
import { v4 as uuid } from 'uuid'

export default {
  inheritAttrs: false,
  props: {
    id: {
      type: String,
      default() {
        return `select-input-${uuid()}`
      },
    },
    error: String,
    label: String,
    modelValue: [String, Number, Boolean],
    contactLink: String,
  },
  emits: ['update:modelValue'],
  data() {
    return {
      selected: this.modelValue,
    }
  },
  watch: {
    modelValue(newValue) {
      this.selected = newValue;
    },
    selected(newValue) {
      this.$emit('update:modelValue', newValue);
    },
  },
  methods: {
    handleChange(event) {
      this.$emit('update:modelValue', event.target.value);
    },
  },
}
</script>
